import { Provider } from "react-redux";
import { SoundProvider } from "react-sounds";
import rpc from "@1games-ru/rage-rpc";
import { Theme } from "@radix-ui/themes";
import useHoverWatcher from "@/core/helpers/useHoverWatcher";
import { KeyPressProvider } from "@/core/keyPressManager";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";
import { useStore } from "@/core/store";
import soundtrackDict from "@/shared/sounds";
import MainContainer from "@/domains/main/containers/MainContainer.tsx";
import ScreenshotContainer from "@/domains/screenshot/containers/ScreenshotContainer";
import ToastSubscriberContainer from "@/domains/toasts/containers/ToastSubscriberContainer";

const sounds = Object.values(soundtrackDict);

declare global {
  interface Window {
    RpcMpProvider: typeof RpcMpProvider;
  }
}

window.rpc = rpc;
window.RpcMpProvider = RpcMpProvider;

function App() {
  const store = useStore();
  useHoverWatcher();

  return (
    <Provider store={store}>
      <SoundProvider preload={sounds} initialEnabled>
        <KeyPressProvider>
          <Theme appearance="dark" accentColor="red" id="theme-root">
            <MainContainer />
            <ScreenshotContainer />
            <ToastSubscriberContainer />
          </Theme>
        </KeyPressProvider>
      </SoundProvider>
    </Provider>
  );
}

export default App;
